import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PriceHistoryPage } from '@/features/market/price-history-page';

const searchSchema = z.object({ region: z.string().optional().catch(undefined) });

export const Route = createFileRoute('/_app/marketplace/prices/$productId')({
  validateSearch: searchSchema,
  component: HistoryRoute,
});

function HistoryRoute() {
  const { productId } = Route.useParams();
  const { region } = Route.useSearch();
  return <PriceHistoryPage productId={productId} region={region ?? ''} />;
}
